"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const config_1 = require("config");
const getIdentityTypeName = (type) => {
    return config_1.VERIFICATION_METHODS.find((item) => item.value === type)?.key;
};
exports.default = getIdentityTypeName;
